import { render } from "./Comisiones.vue?vue&type=template&id=a93ea498&scoped=true"
import script from "./Comisiones.vue?vue&type=script&lang=js"
export * from "./Comisiones.vue?vue&type=script&lang=js"

import "./Comisiones.vue?vue&type=style&index=0&id=a93ea498&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a93ea498"]])

export default __exports__